/** @format */

import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import GridContainer from '../../../components/Grid/GridContainer';
import SearchBar from 'material-ui-search-bar';

import I18n from '../../../components/Translate/I18n';
import I18nSimple from '../../../core/i18n';
import adescomStyle from 'assets/jss/adescom/adescomStyle';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import { msisdnActions, msisdnConstants } from '../../../modules/msisdn/actions';
import TouchButton from '../../../components/Buttons/TouchButton';
import Pager from '../../../components/Adescom/Pager';
import { store } from '../../../core/store';
import { msisdnReducers } from '../../../modules/msisdn/reducers';

class MsisdnChooseNumberList extends PureComponent {
    constructor(props) {
        super(props);

        store.injectReducer('msisdnReducers', msisdnReducers);

        this.elementPerPage = 10;
        const filter = [
            { name: 'itemsPerPage', value: this.elementPerPage },
            { name: 'numberState', value: 0 },
        ];
        if (this.props.platformResellerId) {
            filter.push({ name: 'ownerPlatformResellerId', value: this.props.platformResellerId });
        }
        this.state = {
            search: '',
            filter: filter,
            orders: [{ name: 'msisdn', value: 'asc' }],
        };
        this.init();
    }

    init = () => {
        this.loadNumbers(this.state.filter);
    };

    loadNumbers = (searchOptions) => {
        const { dispatch } = this.props;
        dispatch(
            msisdnActions.getList(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/platform_msisdn_pool_numbers')),
                searchOptions,
                this.state.orders,
                msisdnConstants.LIST_POOL_NUMBERS_CHOOSE
            )
        );
    };

    onPaginationSearch = (uri) => {
        const { dispatch } = this.props;
        dispatch(
            msisdnActions.getList(FormGeneralHelper.getByUri(uri), this.state.filter, this.state.orders, msisdnConstants.LIST_POOL_NUMBERS_CHOOSE)
        );
    };

    searchBarOnChangeCallback = (e) => {
        this.setState({
            search: e,
        });
    };

    onCancelSearch = () => {
        if (this.state.search.length > 0) {
            this.setState(
                {
                    search: '',
                },
                this.init()
            );
        }
    };

    onRequestSearch = () => {
        const filter = this.state.filter;
        filter.push({ name: 'msisdn', value: this.state.search });
        this.loadNumbers(filter);
    };

    render() {
        const { classes, numbersList, clicked } = this.props;
        const tableCellRoot = { root: classes.tableCellRoot };

        if (numbersList) {
            return (
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell colSpan={2}>
                                <Paper>
                                    <SearchBar
                                        value={this.state.search}
                                        onCancelSearch={this.onCancelSearch}
                                        onChange={this.searchBarOnChangeCallback}
                                        onRequestSearch={this.onRequestSearch}
                                        placeholder={I18nSimple.t('pools:pool.find_number_in_pool')}
                                        style={{
                                            margin: '0 auto',
                                        }}
                                    />
                                </Paper>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell padding="none" align="left" classes={tableCellRoot}>
                                <I18n trans="simcard:list.msisdn" />
                            </TableCell>
                            <TableCell padding="none" align="right" classes={tableCellRoot}>
                                <I18n trans="general:common.commands" />
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {numbersList &&
                            numbersList['hydra:member'].map((row) => {
                                return (
                                    <TableRow key={row.id}>
                                        <TableCell align="left" classes={tableCellRoot}>
                                            {row.msisdn}
                                        </TableCell>
                                        <TableCell align="right" classes={tableCellRoot}>
                                            <TouchButton callback={clicked} callbackParam={{ uri: row['@id'], msisdn: row.msisdn }} />
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                    <TableFooter>
                        <TableRow>
                            <TableCell colSpan={2} className={classes.center}>
                                {numbersList && numbersList['hydra:view'] && (
                                    <Pager callback={this.onPaginationSearch} views={numbersList['hydra:view']} />
                                )}
                            </TableCell>
                        </TableRow>
                    </TableFooter>
                </Table>
            );
        } else {
            return (
                <GridContainer justify="center">
                    <CircularProgress />
                </GridContainer>
            );
        }
    }
}

MsisdnChooseNumberList.propTypes = {
    classes: PropTypes.object.isRequired,
    clicked: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => {
    const { msisdnReducers } = state;
    if (msisdnReducers === undefined) {
        return { ...state };
    }
    let numbersList = null;
    if (msisdnReducers && msisdnReducers.collections) {
        numbersList = msisdnReducers.collections;
    }
    return {
        type: msisdnReducers.type,
        numbersList: numbersList,
    };
};
const enhance = compose(connect(mapStateToProps), withStyles(adescomStyle));
const Enhance = enhance(MsisdnChooseNumberList);
export default Enhance;
